/**
 * Admin — Health layout route (4 sub-tabs).
 *
 * Sub-tabs:
 *   /admin/health             — Overview (default)  — service status grid + air-gap counter
 *   /admin/health/services    — Per-service detail with metrics + restart actions
 *   /admin/health/infra       — Host info, GPU, disk, memory
 *   /admin/health/pipeline    — Ingest pipeline stages + throughput
 */

import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router';
import {
  Activity, Boxes, Cpu, Workflow,
} from 'lucide-react';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/admin/health')({
  component: HealthLayout,
});

const SUB_TABS = [
  { label: 'Overview',   path: '/admin/health',          icon: Activity },
  { label: 'Services',   path: '/admin/health/services', icon: Boxes },
  { label: 'Infra',      path: '/admin/health/infra',    icon: Cpu },
  { label: 'Pipeline',   path: '/admin/health/pipeline', icon: Workflow },
];

function HealthLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="border-b bg-background px-6 shrink-0">
        <nav className="flex items-center gap-1 overflow-x-auto whitespace-nowrap">
          {SUB_TABS.map(t => {
            const Icon = t.icon;
            const isActive = location.pathname === t.path
              || (t.path !== '/admin/health' && location.pathname.startsWith(t.path));
            const isExact = location.pathname === '/admin/health' || location.pathname === '/admin/health/';
            const active = t.path === '/admin/health' ? isExact : isActive;
            return (
              <Link
                key={t.path}
                to={t.path as any}
                title={t.label}
                aria-label={t.label}
                className={cn(
                  'inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium border-b-2 transition-colors -mb-px shrink-0 whitespace-nowrap',
                  active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                <Icon className="h-3.5 w-3.5 shrink-0" />
                <span className="hidden md:inline">{t.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
